import type { CustomerSummaryDto } from '../types/jobCostOverview';

const formatCurrency = (amount: number) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);

interface CustomerSummaryPanelProps {
  summary: CustomerSummaryDto;
}

export function CustomerSummaryPanel({ summary }: CustomerSummaryPanelProps) {
  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="px-2 py-1.5 border-b border-border bg-gray-50 rounded-t-lg">
        <h4 className="text-xs font-semibold">Customer Summary</h4>
      </div>
      <div className="p-2 space-y-1 text-xs">
        <div className="flex justify-between">
          <span className="text-muted-foreground">Total Contracts</span>
          <span className="font-medium">{formatCurrency(summary.totalContracts)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-muted-foreground">Total Paid</span>
          <span className="font-medium">{formatCurrency(summary.totalPaid)}</span>
        </div>
        <div className="flex justify-between pt-1 border-t border-border">
          <span className="font-semibold">Balance Due</span>
          <span className={`font-bold ${summary.balanceDue > 0 ? 'text-red-600' : 'text-green-600'}`}>
            {formatCurrency(summary.balanceDue)}
          </span>
        </div>
      </div>
    </div>
  );
}
